import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_POSTHOG_API_KEY as string;
const host = import.meta.env.VITE_POSTHOG_HOST as string;

export function initPostHog() {
  if (!apiKey) return;
  posthog.init(apiKey, {
    api_host: host || 'https://us.i.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
}

export function identifyUser(email: string, properties?: Record<string, unknown>) {
  if (!apiKey) return;
  posthog.identify(email, properties);
}

export function resetUser() {
  if (!apiKey) return;
  posthog.reset();
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!apiKey) return;
  posthog.capture(event, properties);
}
